import { useState } from 'react';
import { updateStore } from '../../../utils/queries';
import { padCustomerNumber, lookupPaceCustomerBundle, applyPaceCustomerDefaults } from '../../../utils/paceOnboarding';

export default function PaceConnectPanel({ storeId, onConnected }) {
	const [customerNumber, setCustomerNumber] = useState('');
	const [connecting, setConnecting] = useState(false);
	const [error, setError] = useState('');

	const handleConnect = async () => {
		if (!customerNumber || connecting) return;
		const padded = padCustomerNumber(customerNumber);
		setCustomerNumber(padded);
		setConnecting(true);
		setError('');
		try {
			const bundle = await lookupPaceCustomerBundle(padded);
			if (!bundle.success) {
				setError(bundle.error);
				return;
			}

			const updateResult = await updateStore(storeId, { erpCustomerNumber: padded });
			if (!updateResult?.success) {
				setError(updateResult?.error?.message || 'Failed to save the ERP customer number.');
				return;
			}

			const defaultsResult = await applyPaceCustomerDefaults(storeId, padded, bundle.data);
			if (!defaultsResult?.success) {
				setError(defaultsResult?.error || 'Failed to save the ERP connection.');
				return;
			}

			onConnected?.();
		} finally {
			setConnecting(false);
		}
	};

	return (
		<div>
			<label>ERP Customer Number</label>
			{/* <p className='text-xs text-gray-400 mb-1'>Padded to 8 characters automatically, e.g. "1656" becomes "00001656".</p> */}
			<div className='flex gap-2'>
				<input
					className='form-input'
					placeholder='00001234'
					disabled={connecting}
					value={customerNumber}
					onChange={(e) => {
						setCustomerNumber(e.target.value);
						setError('');
					}}
					onKeyDown={(e) => {
						if (e.key === 'Enter' && !connecting && customerNumber) handleConnect();
					}}
				/>
				<button
					type='button'
					className='btn-secondary shrink-0'
					disabled={connecting || !customerNumber}
					onClick={handleConnect}
				>
					{connecting ? 'Connecting...' : 'Connect to ERP'}
				</button>
			</div>
			{connecting && (
				<p className='text-xs text-gray-500 mt-1'>Looking up the customer and setting up defaults in ERP -- this can take a moment.</p>
			)}
			{error && <p className='text-sm text-pi-red mt-1'>{error}</p>}
		</div>
	);
}
